import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StandardElectricService {

  constructor(protected http: HttpClient) { }

  list(): Observable<string[]> {
    return this.http.get<any[]>('/standard-electrics')
      .pipe(
        map(items => items.map(i => i.code))
      );
  }

  add(code: string): Observable<string> {
    return this.http.post<any>('/standard-electrics', {code})
      .pipe(
        map(data => data.code)
      );
  }

  remove(code: string): Observable<string> {
    return this.http.delete<any>(`/standard-electrics/${code}`)
    .pipe(
      map(data => data.code)
    );
  }
}
